import Styles from './styles';

export default Styles.Label;
